<div *ngIf="subject" class="card">
  <div class="card-header compact">
    <h1 [matTooltip]="subject.label" matTooltipClass="tooltip-stretch" class="ellipsis">{{ subject.label || ('subjectInfo.noSubjectLabel' | translate) }}</h1>
    <div class="card-actions">
      <app-button-group class="small fill-white">
        <button *ngIf="permissions.deleteContainer" test-id="delete-button" type="button" mat-stroked-button (click)="deleteSubject()" [attr.aria-label]="'subjectInfo.buttons.delete.ariaLabel' | translate">
          <mat-icon class="xs">delete</mat-icon>
        </button>
        <button *ngIf="permissions.viewAuditTrail" type="button" mat-stroked-button (click)="viewAuditTrail()" aria-label="View Subject Audit Trail" [matTooltip]="'queriesDialog.actions.viewAuditTrail' | translate">
          <mat-icon class="xs">list</mat-icon>
        </button>
        <!-- Save managed externally -->
        <!-- <button *ngIf="permissions.editMetadata" test-id="save-button" type="button"
          mat-flat-button color="accent" (click)="saveChanges()" [disabled]="metadata.invalid">
          {{ 'common.actions.save' | translate }}
        </button> -->
        <button *ngIf="permissions.editMetadata" test-id="cancel-button" type="button"
          mat-stroked-button (click)="resetForm()">
          {{ 'common.actions.reset' | translate }}
        </button>
      </app-button-group>
    </div>
  </div>
  <form [formGroup]="metadata">
    <div class="info-row">
      <span class="field-tooltip"></span>
      <span class="field-label">{{ 'subjectInfo.label.label' | translate }}</span>
      <div class="field-value">
        <span *ngIf="!permissions.editMetadata">{{ subject.label }}</span>
        <input *ngIf="permissions.editMetadata" test-id="label" type="text" formControlName="label" [placeholder]="'subjectInfo.label.placeholder' | translate" autocomplete="off">
      </div>
      <div class="field-error">
        <span *ngIf="metadata.get('label').hasError('required')">{{ 'subjectInfo.label.fieldRequired' | translate }}</span>
        <span *ngIf="metadata.get('label').hasError('minlength')">{{ 'common.errors.minLength' | translate }}</span>
        <span *ngIf="metadata.get('label').hasError('maxlength')">{{ 'common.errors.maxLength' | translate }}</span>
      </div>
      <div class="field-action-menu">
        <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.label.label' | translate" fieldKey="label"></fw-action-menu>
      </div>
    </div>

    <div class="info-row">
      <span class="field-tooltip"></span>
      <span class="field-label">{{ 'subjectInfo.type.label' | translate }}</span>
      <div class="field-value">
        <span *ngIf="!permissions.editMetadata">{{ subject.type | titlecase }}</span>
        <mat-radio-group *ngIf="permissions.editMetadata" formControlName="type" [attr.aria-label]="'subjectInfo.type.ariaLabel' | translate">
          <mat-radio-button *ngFor="let option of options.type" [attr.test-id]="'radio-button-' + option.value" [value]="option.value">
            {{ option.label || (option.value | titlecase) }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="field-error"></div>
      <div class="field-action-menu">
        <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.type.label' | translate" fieldKey="type"></fw-action-menu>
      </div>
    </div>

    <ng-container *ngIf="type === 'human' || !type">
      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.firstname.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.firstname }}</span>
          <input *ngIf="permissions.editMetadata" test-id="first-name" type="text" formControlName="firstname" [placeholder]="'subjectInfo.firstname.placeholder' | translate" autocomplete="off">
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.firstname.label' | translate" fieldKey="firstname"></fw-action-menu>
        </div>
      </div>

      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.lastname.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.lastname }}</span>
          <input *ngIf="permissions.editMetadata" test-id="last-name" type="text" formControlName="lastname" [placeholder]="'subjectInfo.lastname.placeholder' | translate" autocomplete="off">
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.lastname.label' | translate" fieldKey="lastname"></fw-action-menu>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="type === 'human' || type ==='animal' || !type">
      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.dateOfBirth.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.date_of_birth | date: 'yyyy-MM-dd' }}</span>
          <ng-container *ngIf="permissions.editMetadata">
            <input formControlName="dateOfBirth" matInput [matDatepicker]="datepicker" placeholder="YYYY-MM-DD" class="date-input" autocomplete="off">
            <mat-datepicker-toggle [for]="datepicker" class="xs">
              <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #datepicker></mat-datepicker>
          </ng-container>
        </div>
        <div class="field-error">
          <span *ngIf="metadata.get('dateOfBirth').invalid">{{ 'subjectInfo.dateOfBirth.invalid' | translate }}</span>
        </div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.dateOfBirth.label' | translate" fieldKey="date_of_birth"></fw-action-menu>
        </div>
      </div>

      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.state.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.state | titlecase }}</span>
          <mat-select *ngIf="permissions.editMetadata" test-id="state" formControlName="state">
            <mat-option value="">{{ 'subjectInfo.state.placeholder' | translate }}</mat-option>
            <mat-option *ngFor="let option of options.state" [attr.test-id]="'option-' + option.value" [value]="option.value">
              {{ option.label || (option.value | titlecase) }}
            </mat-option>
          </mat-select>
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.state.label' | translate" fieldKey="state"></fw-action-menu>
        </div>
      </div>

      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.sex.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.sex | titlecase }}</span>
          <mat-select *ngIf="permissions.editMetadata" test-id="sex" formControlName="sex">
            <mat-option value="">{{ 'subjectInfo.sex.placeholder' | translate }}</mat-option>
            <mat-option *ngFor="let option of options.sex" [attr.test-id]="'option-' + option.value" [value]="option.value">
              {{ option.label || (option.value | titlecase) }}
            </mat-option>
          </mat-select>
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.sex.label' | translate" fieldKey="sex"></fw-action-menu>
        </div>
      </div>

      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.cohort.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.cohort | titlecase }}</span>
          <mat-select *ngIf="permissions.editMetadata" test-id="cohort" formControlName="cohort">
            <mat-option value="">{{ 'subjectInfo.cohort.placeholder' | translate }}</mat-option>
            <mat-option *ngFor="let option of options.cohort" [attr.test-id]="'option-' + option.value" [value]="option.value">
              {{ option.label || (option.value | titlecase) }}
            </mat-option>
          </mat-select>
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.cohort.label' | translate" fieldKey="cohort"></fw-action-menu>
        </div>
      </div>

      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.mlset.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.mlset | titlecase }}</span>
          <mat-select *ngIf="permissions.editMetadata" test-id="mlset" formControlName="mlset">
            <mat-option value="">{{ 'subjectInfo.mlset.placeholder' | translate }}</mat-option>
            <mat-option *ngFor="let option of options.mlset" [attr.test-id]="'option-' + option.value" [value]="option.value">
              {{ option.label || (option.value | titlecase) }}
            </mat-option>
          </mat-select>
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.mlset.label' | translate" fieldKey="mlset"></fw-action-menu>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="type === 'human' || !type">
      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.race.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.race }}</span>
          <mat-select *ngIf="permissions.editMetadata" test-id="race" formControlName="race">
            <mat-option value="">{{ 'subjectInfo.race.placeholder' | translate }}</mat-option>
            <mat-option *ngFor="let option of options.race" [attr.test-id]="'option-' + option.value" [value]="option.value">
              {{ option.label || (option.value | titlecase) }}
            </mat-option>
          </mat-select>
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.race.label' | translate" fieldKey="race"></fw-action-menu>
        </div>
      </div>

      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.ethnicity.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.ethnicity }}</span>
          <mat-select *ngIf="permissions.editMetadata" test-id="ethnicity" formControlName="ethnicity">
            <mat-option value="">{{ 'subjectInfo.ethnicity.placeholder' | translate }}</mat-option>
            <mat-option *ngFor="let option of options.ethnicity" [attr.test-id]="'option-' + option.value" [value]="option.value">
              {{ option.label || (option.value | titlecase) }}
            </mat-option>
          </mat-select>
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.ethnicity.label' | translate" fieldKey="ethnicity"></fw-action-menu>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="type === 'animal' || !type">
      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.species.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.species | titlecase }}</span>
          <mat-select *ngIf="permissions.editMetadata" test-id="species" formControlName="species">
            <mat-option value="">{{ 'subjectInfo.species.placeholder' | translate }}</mat-option>
            <mat-option *ngFor="let option of options.species" [attr.test-id]="'option-' + option.value" [value]="option.value">
              {{ option.label || (option.value | titlecase) }}
            </mat-option>
          </mat-select>
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.species.label' | translate" fieldKey="species"></fw-action-menu>
        </div>
      </div>

      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">{{ 'subjectInfo.strain.label' | translate }}</span>
        <div class="field-value">
          <span *ngIf="!permissions.editMetadata">{{ subject.strain }}</span>
          <input *ngIf="permissions.editMetadata" test-id="strain" type="text" formControlName="strain" [placeholder]="'subjectInfo.strain.placeholder' | translate" autocomplete="off">
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu [auditable]="subject" [fieldLabel]="'subjectInfo.strain.label' | translate" fieldKey="strain"></fw-action-menu>
        </div>
      </div>
    </ng-container>
  </form>
</div>
